import React from "react";
import styled from "styled-components";
import Header from "../commons/Header";
import Footer from "../commons/Footer";
import ProvideLandingSearch from "../providers/ProvideLandingSearch";

import HeroBanner from "./sections/HeroBanner";
import WebinarCarousel from "./sections/WebinarCarousel";
import TaxsamCommunity from "./sections/TaxsamCommunity";
import SertifikasiCarousel from "./sections/SertifikasiCarousel";
import RekamanCarousel from "./sections/RekamanCarousel";
import CompanyLogos from "./sections/CompanyLogos";
import TalksamtalkCarousel from "./sections/TalksamtalkCarousel";
import SectionErrorBoundary from "./SectionErrorBoundary";

const Page = styled.div`
  background: #ffffff;
  min-height: 100vh;
  color: #1f2937;
  font-family: "Montserrat", sans-serif;

  &[data-theme="dark"] {
    background: #0f172a;
    color: #f3f4f6;
  }
`;

// Theme handoff: HomesController passes `theme` ('dark'|'light') based on the
// `dark_mode_v1` FeatureToggle. We set `data-theme` on the Page wrapper; all
// descendant styled-components use `[data-theme="dark"] &` selectors.
// Light is the fallback when the prop is missing or unknown.
export default function HomesApp({ theme = "light", banners }) {
  const resolved = theme === "dark" ? "dark" : "light";

  // Also expose on html so any legacy CSS (if added later) can target globally.
  React.useEffect(() => {
    document.documentElement.setAttribute("data-theme", resolved);
    return () => document.documentElement.removeAttribute("data-theme");
  }, [resolved]);

  return (
    <ProvideLandingSearch>
      <Page data-theme={resolved}>
        <Header />
        <SectionErrorBoundary name="Hero"><HeroBanner banners={banners} /></SectionErrorBoundary>
        <SectionErrorBoundary name="Webinar"><WebinarCarousel /></SectionErrorBoundary>
        <SectionErrorBoundary name="Community"><TaxsamCommunity /></SectionErrorBoundary>
        <SectionErrorBoundary name="Sertifikasi"><SertifikasiCarousel /></SectionErrorBoundary>
        <SectionErrorBoundary name="Rekaman"><RekamanCarousel /></SectionErrorBoundary>
        <SectionErrorBoundary name="CompanyLogos"><CompanyLogos /></SectionErrorBoundary>
        <SectionErrorBoundary name="Talksamtalk"><TalksamtalkCarousel /></SectionErrorBoundary>
        <Footer />
      </Page>
    </ProvideLandingSearch>
  );
}
